import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costRows, sundayNight } from '../data/copy';
export function ProblemSection() {
  return <section className="w-full bg-sand py-10 sm:py-14" aria-labelledby="problem-heading" data-id="element-138" data-mp="30gxva0ohrloc">
      <div className="mx-auto max-w-5xl px-6" data-id="element-139" data-mp="2vqhhgfgrdy1g">
        <SectionHeading eyebrow="💬 The Sunday night spiral" title={<span id="problem-heading" data-id="element-141" data-mp="39hmagypmfs2t">Does this sound familiar?</span>} lead="You have a clinic tomorrow morning. You’re staring at a blank notebook or scrolling through random clips, trying to piece together a session that flows, makes sense for your players’ level, and actually looks professional." data-id="element-140" data-mp="2vppl32fc7wa4" />

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-142" data-mp="3eh8ovbh6red7">
          {sundayNight.map(line => <li key={line} className="rounded-full border border-line bg-shell px-4 py-2 font-sans text-[0.8rem] text-stone" data-id="element-143" data-mp="1p1j0n3jr95we">
              {line}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-2xl text-center" data-id="element-144" data-mp="jd3pwuneonul">
          <p className="font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-145" data-mp="jey9o5mxy9x3">
            It’s not that you don’t know pickleball. It’s that nobody gave you a
            structured system.
          </p>
          <p className="mx-auto mt-4 max-w-readable font-sans text-[0.95rem] leading-relaxed text-stone" data-id="element-146" data-mp="sbp4yfto5kqm">
            You’ve been reinventing the wheel for every single class. The time
            you should spend resting is spent planning — and then there’s that
            nagging feeling that you could have been better prepared when you
            step onto the court.
          </p>
        </div>

        <div className="mt-11" data-id="element-147" data-mp="1bzy63fd6x129">
          <h3 className="text-center font-display text-lg font-bold uppercase tracking-[0.1em] text-flame sm:text-xl" data-id="element-148" data-mp="1g3w4fnuoy7u9">
            The high cost of being unstructured
          </h3>

          <div className="mt-6 overflow-hidden rounded-3xl border border-line bg-shell shadow-soft" data-id="element-149" data-mp="3huhbswji47xe">
            <table className="w-full border-collapse text-left" data-id="element-150" data-mp="p00mtvr09x1r">
              <caption className="sr-only" data-id="element-151" data-mp="p2d2g29ajvbn">
                The cost of coaching without a structured system
              </caption>
              <thead data-id="element-152" data-mp="y0p3ky7sabic">
                <tr className="bg-navy-deep" data-id="element-153" data-mp="y174471hbbw2">
                  <th scope="col" className="px-5 py-3.5 font-sans text-xs font-semibold uppercase tracking-[0.16em] text-shell sm:px-7" data-id="element-154" data-mp="xyugbd91i7b3">
                    The problem
                  </th>
                  <th scope="col" className="px-5 py-3.5 font-sans text-xs font-semibold uppercase tracking-[0.16em] text-lime sm:px-7" data-id="element-155" data-mp="17x1u5n81898v">
                    The impact
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-156" data-mp="1cq3cy6bd0sxq">
                {costRows.map(row => <tr key={row.problem} className="border-t border-line" data-id="element-157" data-mp="1cr65eiobz3fr">
                    <th scope="row" className="px-5 py-4 align-top font-sans text-[0.85rem] font-medium leading-relaxed text-ink sm:px-7 sm:text-[0.9rem]" data-id="element-158" data-mp="1qoup3n6nw4j8">
                      <span className="flex items-start gap-2.5" data-id="element-159" data-mp="1looqfn1z5hrn">
                        <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame" strokeWidth={3} aria-hidden="true" data-id="element-160" data-mp="25cuohdr8n5bg" />
                        {row.problem}
                      </span>
                    </th>
                    <td className="px-5 py-4 align-top font-sans text-[0.85rem] leading-relaxed text-stone sm:px-7 sm:text-[0.9rem]" data-id="element-161" data-mp="1wb3hm5kyosg0">
                      {row.impact}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mx-auto mt-9 max-w-xl text-center font-display text-xl font-bold leading-snug text-ink" data-id="element-162" data-mp="1rdbtznrcnshm">
          Stop wasting your freedom. You have the dedication —{' '}
          <span className="text-navy" data-id="element-163" data-mp="1hlz24w5jx2bl">now you need the system.</span>
        </p>
      </div>
    </section>;
}